/**
 * @generated SignedSource<<5d3ce798b13138ad2b3a724c051abf8a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type entityOnelineMenuQueueItemsEdge$data = ReadonlyArray<{
  readonly node: {
    readonly name?: string;
    readonly urlAlias?: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  };
  readonly " $fragmentType": "entityOnelineMenuQueueItemsEdge";
}>;
export type entityOnelineMenuQueueItemsEdge$key = ReadonlyArray<{
  readonly " $data"?: entityOnelineMenuQueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"entityOnelineMenuQueueItemsEdge">;
}>;

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "urlAlias",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "entityOnelineMenuQueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "Topic",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "Section",
          "abstractKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityLink"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};
})();

(node as any).hash = "0333efbd368c68d04739d3116be07a17";

export default node;
